module.exports = __webpack_public_path__ + "static/media/One side Angle's Class II4.a6f0aa22.png";